
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAnalytics } from '@/hooks/useAnalytics';

const CTASection = () => {
  const analytics = useAnalytics();
  
  const trackCTA = () => {
    analytics.trackCTA('start_comparing', 'homepage_bottom', {
      search_query: 'top+Himalayan+treks',
      button_text: 'Start Comparing Treks'
    });
  };
  
  return (
    <section className="py-16 md:py-20 px-4 bg-primary dark:bg-secondary text-primary-foreground">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col items-center text-center space-y-6 max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-bold tracking-tight">
            Ready to find your perfect trek?
          </h2>
          <p className="text-base md:text-lg text-primary-foreground/90 dark:text-secondary-foreground/80 max-w-2xl">
            Compare packages, prices, and features from different adventure companies to find the best fit for your next Himalayan adventure.
          </p>
          <Link to="/search?q=top+Himalayan+treks">
            <Button 
              size="lg" 
              className="rounded-full mt-4 bg-accent text-accent-foreground hover:bg-accent/90"
              onClick={trackCTA}
            >
              Start Comparing Treks <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
